export function GetGoogleMapAPI(envVariableNameForGoogleMapAPI: string) {
  // Define a mapping object for environment variable names
  const envVariableMappings: Record<string, string> = {
    GLOBAL_SITE_GOOGLE_MAP_API_KEY: process.env.GLOBAL_SITE_GOOGLE_MAP_API_KEY || '',
    ADVOCATEHEALTHCOM_SITE_GOOGLE_MAP_API_KEY:
      process.env.ADVOCATEHEALTHCOM_SITE_GOOGLE_MAP_API_KEY || '',
    ADVOCATECHILDRENSHOSPITAL_SITE_GOOGLE_MAP_API_KEY:
      process.env.ADVOCATECHILDRENSHOSPITAL_SITE_GOOGLE_MAP_API_KEY || '',
    ADVOCATEHEALTHORG_SITE_GOOGLE_MAP_API_KEY:
      process.env.ADVOCATEHEALTHORG_SITE_GOOGLE_MAP_API_KEY || '',
    AURORAHEALTHCAREORG_SITE_GOOGLE_MAP_API_KEY:
      process.env.AURORAHEALTHCAREORG_SITE_GOOGLE_MAP_API_KEY || '',
    AURORABAYCARECOM_SITE_GOOGLE_MAP_API_KEY:
      process.env.AURORABAYCARECOM_SITE_GOOGLE_MAP_API_KEY || '',
    ATRIUMHEALTHFLOYDHARBINORG_SITE_GOOGLE_MAP_API_KEY:
      process.env.ATRIUMHEALTHFLOYDHARBINORG_SITE_GOOGLE_MAP_API_KEY || '',
  };

  // Return the value corresponding to the provided environment variable name
  return envVariableMappings[envVariableNameForGoogleMapAPI] || '';
}
